import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { LogoutAsync } from './controller';

export function LogoutRedirect() {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(LogoutAsync());
    }, []);
    return (
        <section id="Logout">
            <div className="container-fluid mt-3 disclaimer minHeight">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex justify-content-center">
                                    <div className="card-content">
                                        <div className="theme-color d-flex h-100 align-items-center">
                                            <p className="m-0">
                                                Logging out...
                                            </p>
                                        </div>
                                       
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}





